module.exports = __webpack_public_path__ + "public-ui/img/b1.4e573898.svg";